<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      width="600px"
      center
    >
      <el-form inline :model="mFormData" label-width="150px" :rules="rules">
        <el-form-item :label="$t('OperatorName')" prop="SellerName">
          <el-input
            :disabled="OnIsEdit()"
            style="width: 300px"
            v-model="mFormData.SellerName"
            :placeholder="$t('EnterOperatorName')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('OperatorAbbreviation')" prop="SampleName">
          <el-input
            clearable
            style="width: 300px"
            v-model="mFormData.SampleName"
            :placeholder="$t('Example')+'：OK'"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('DisplayName')+'  \''" prop="ShowName">
          <!-- 添加问号图标和提示 -->
          <el-tooltip
            style="margin-left: -18px; margin-right: 4px"
            effect="dark"
            :content="$t('ReferenceStyle')"
            placement="top"
          >
            <i
              class="el-icon-question"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
          <el-input
            clearable
            style="width: 300px"
            v-model="mFormData.ShowName"
            :placeholder="$t('Example')+'：9 f'"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Status')" prop="State">
          <el-radio-group v-model="mFormData.State">
            <el-radio label="1">{{$t('Enable')}}</el-radio>
            <el-radio label="2">{{$t('deactivate')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  :label="$t('Remarks')">
          <el-input
            type="textarea"
            style="width: 300px"
            v-model="mFormData.Memo"
            :placeholder="$t('EnterRemark')"
          ></el-input>
        </el-form-item>
        <el-form-item label="社媒链接" required v-if="OnIsEdit()">
          <el-button type="text" @click="openSocialDialog">点击配置社媒链接</el-button>
          <span class="social-link-count" v-if="socialLinkCount">已配置 {{ socialLinkCount }} 项</span>
        </el-form-item>
        <el-form-item label="客服链接" required v-if="OnIsEdit()">
          <el-button type="text" @click="openCustomerServiceDialog">点击配置客服链接</el-button>
          <span class="social-link-count" v-if="customerServiceLinkCount">已配置 {{ customerServiceLinkCount }} 项</span>
        </el-form-item>
        <el-form-item label="Icon '">
          <!-- 添加问号图标和提示 -->
          <el-tooltip
            style="margin-left: -18px; margin-right: 4px"
            effect="dark"
            :content="$t('PageTitle')"
            placement="top"
          >
            <i
              class="el-icon-question"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
          <div style="margin-top: -20px">
            <el-upload
              class="avatar-uploader"
              :action="this.$global.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="OnHandleIconSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="{ 'x-token': token }"
            >
              <img
                v-if="mFormData.Icon"
                :src="`${baseurl}${mFormData.Icon}`"
                class="avatar"
                width="100"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="block">
              <p>{{$t('ReferenceStyle')}}</p>
              <el-image
                style="width: 40px; height: 40px"
                :src="mUrlIcon"
              ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('PureImageLogo')+'  \''">
          <!-- 添加问号图标和提示 -->
          <el-tooltip
            style="margin-left: -18px; margin-right: 4px"
            effect="dark"
            :content="$t('LoginLogo')"
            placement="top"
          >
            <i
              class="el-icon-question"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
          <div style="margin-top: -20px">
            <el-upload
              class="avatar-uploader"
              :action="this.$global.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="OnHandleLogoSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="{ 'x-token': token }"
            >
              <img
                v-if="mFormData.Logo"
                :src="`${baseurl}${mFormData.Logo}`"
                class="avatar"
                width="100"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="block">
              <p>{{$t('ReferenceStyle')}}</p>
              <el-image
                style="width: 40px; height: 40px"
                :src="mUrlIcon"
              ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('ImageNameLogo')+'  \''">
          <!-- 添加问号图标和提示 -->
          <el-tooltip
            style="margin-left: -18px; margin-right: 4px"
            effect="dark"
            :content="$t('FrontEndLogoStyle')"
            placement="top"
          >
            <i
              class="el-icon-question"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
          <div style="margin-top: -20px">
            <el-upload
              class="avatar-uploader"
              :action="this.$global.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="OnHandleLogo2Success"
              :before-upload="beforeAvatarUpload"
              :headers="{ 'x-token': token }"
            >
              <img
                v-if="mFormData.Logo2"
                :src="`${baseurl}${mFormData.Logo2}`"
                class="avatar"
                width="100"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="block">
              <p>{{$t('ReferenceStyle')}}</p>
              <el-image
                style="width: 90px; height: 30px"
                :src="mUrlLogo2"
              ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="ios图标">
          <!-- 添加问号图标和提示 -->
          <el-tooltip
            style="margin-left: -18px; margin-right: 4px"
            effect="dark"
            :content="$t('FrontEndLogoStyle')"
            placement="top"
          >
            <i
              class="el-icon-question"
              style="margin-left: 10px; cursor: pointer"
            ></i>
          </el-tooltip>
          <div style="margin-top: -20px">
            <el-upload
              class="avatar-uploader"
              :action="this.$global.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="OnHandleIosIconSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="{ 'x-token': token }"
            >
              <img
                v-if="mFormData.IosIcon"
                :src="`${baseurl}${mFormData.IosIcon}`"
                class="avatar"
                width="100"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="OnClickSure"
          >{{ $t('Confirm') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="社媒链接配置"
      :visible.sync="socialVisible"
      width="620px"
      center
      append-to-body
      custom-class="seller-social-dialog"
    >
      <el-form :model="socialForm" label-width="125px">
        <el-form-item v-for="item in socialFields" :key="item.key" :label="item.label + '链接：'">
          <el-input v-model.trim="socialForm[item.key]" clearable placeholder="请输入以 http:// 或 https:// 开头的链接"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSocialDialog">取消</el-button>
        <el-button type="primary" @click="confirmSocialLinks">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="客服链接配置"
      :visible.sync="customerServiceVisible"
      width="620px"
      center
      append-to-body
      custom-class="seller-customer-service-dialog"
    >
      <el-form :model="customerServiceDraft" label-width="135px">
        <el-form-item v-for="item in customerServiceFields" :key="item.key" :label="item.label + '：'">
          <el-input
            v-model.trim="customerServiceDraft[item.key]"
            clearable
            placeholder="请输入链接"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCustomerServiceDialog">取消</el-button>
        <el-button type="primary" @click="confirmCustomerServiceLink">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mFormData: {
        SellerName: "",
        SampleName: "",
        ShowName: "",
        State: "1",
        Memo: "",
        Icon: "",
        Logo: "",
        Logo2: "",
        IosIcon: "",
        SocialLinks: "",
        CustomerServiceLink: "",
        CustomerLinks: "",
      },
      socialVisible: false,
      customerServiceVisible: false,
      customerServiceFields: [
        { id: 1, key: "CustomService", label: "在线客服链接" },
        { id: 2, key: "CustomSkype", label: "Skype客服链接" },
        { id: 3, key: "CustomTelegram", label: "TG客服链接" },
        { id: 4, key: "CustomTelegramGroup", label: "官方频道链接" },
        { id: 5, key: "CustomWhatapp", label: "WhatsApp客服链接" },
        { id: 6, key: "CustomSafeW", label: "SafeW客服链接" },
      ],
      customerServiceDraft: {
        CustomService: "",
        CustomSkype: "",
        CustomTelegram: "",
        CustomTelegramGroup: "",
        CustomWhatapp: "",
        CustomSafeW: "",
      },
      socialFields: [
        { id: 1, key: "YoutubeLink", label: "Youtube" },
        { id: 2, key: "InstagramLink", label: "Instagram" },
        { id: 3, key: "FacebookLink", label: "Facebook" },
        { id: 4, key: "TwitterLink", label: "Twitter" },
        { id: 5, key: "TwitchLink", label: "Twitch" },
        { id: 6, key: "DiscordLink", label: "Discord" },
        { id: 7, key: "TiktokLink", label: "Tiktok" },
        { id: 8, key: "TelegramLink", label: "Telegram" },
        { id: 9, key: "WhatsAppLink", label: "WhatsApp" },
      ],
      socialForm: {
        YoutubeLink: "",
        InstagramLink: "",
        FacebookLink: "",
        TwitterLink: "",
        TwitchLink: "",
        DiscordLink: "",
        TiktokLink: "",
        TelegramLink: "",
        WhatsAppLink: "",
      },
      token: sessionStorage.getItem("token"),
      baseurl: JSON.parse(sessionStorage.getItem("userdata")).FileBaseUrl,
      rules: {
        SellerName: [
          { required: true, message: this.$t('EnterOperatorName'), trigger: "blur" },
        ],
        SampleName: [
          { required: true, message: "请输入运营商简称", trigger: "blur" },
        ],
        ShowName: [
          { required: true, message: "请输入显示名称", trigger: "blur" },
        ],
        State: [{ required: true, message: this.$t('StatusQuery'), trigger: "change" }],
      },
      mInitHost: "",
      mUrlIcon:
        "data:image/webp;base64,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",
      mUrlLogo2:
        "data:image/webp;base64,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",
    };
  },
  created() {
    if (this.OnIsEdit()) {
      this.mFormData.SellerName = this.dialogData.row.SellerName;
      this.mFormData.SampleName = this.dialogData.row.SampleName;
      this.mFormData.ShowName = this.dialogData.row.ShowName;
      this.mFormData.State = String(this.dialogData.row.State);
      this.mFormData.Memo = this.dialogData.row.Remark;
      this.mFormData.Icon = this.dialogData.row.Icon;
      this.mFormData.Logo = this.dialogData.row.Logo;
      this.mFormData.Logo2 = this.dialogData.row.Logo2;
      this.mFormData.IosIcon = this.dialogData.row.IosIcon;
      this.mFormData.SocialLinks = this.dialogData.row.SocialLinks || "";
      this.mFormData.CustomerServiceLink =
        this.dialogData.row.CustomerServiceLink ||
        this.dialogData.row.CustomService ||
        this.dialogData.row.CustomeService ||
        this.dialogData.row.KefuLink ||
        "";
      this.applyCustomerServiceLinks(this.dialogData.row);
      this.applySocialLinks(this.dialogData.row);
    }
  },
  computed: {
    socialLinkCount() {
      return this.socialFields.filter((item) => this.socialForm[item.key]).length;
    },
    customerServiceLinkCount() {
      return this.customerServiceFields.filter(
        (item) => this.customerServiceDraft[item.key]
      ).length;
    },
  },
  methods: {
    OnIsAdd() {
      return this.dialogData.opt == 1;
    },
    OnIsEdit() {
      return this.dialogData.opt == 2;
    },
    applySocialLinks(row) {
      let links = row.SocialMedia || row.SocialLinks || {};
      if (typeof links == "string") {
        try {
          links = JSON.parse(links || "{}");
        } catch (e) {
          links = {};
        }
      }
      this.socialFields.forEach((item) => {
        this.socialForm[item.key] = links[item.key] || links[item.id] || row[item.key] || "";
      });
    },
    openSocialDialog() {
      this.applySocialLinks({ SocialLinks: this.mFormData.SocialLinks });
      this.socialVisible = true;
    },
    cancelSocialDialog() {
      this.applySocialLinks({ SocialLinks: this.mFormData.SocialLinks });
      this.socialVisible = false;
    },
    confirmSocialLinks() {
      for (let i = 0; i < this.socialFields.length; i++) {
        const item = this.socialFields[i];
        const value = this.socialForm[item.key];
        if (value && !/^https?:\/\/\S+$/i.test(value)) {
          this.$message.error(`${item.label}链接需要以 http:// 或 https:// 开头`);
          return;
        }
      }
      const links = {};
      this.socialFields.forEach((item) => {
        if (this.socialForm[item.key]) links[item.id] = this.socialForm[item.key];
      });
      this.mFormData.SocialLinks = JSON.stringify(links);
      this.socialVisible = false;
      this.$message.success("社媒链接配置已保存");
    },
    openCustomerServiceDialog() {
      this.applyCustomerServiceLinks({
        CustomerLinks: this.mFormData.CustomerLinks,
        CustomerServiceLink: this.mFormData.CustomerServiceLink,
      });
      this.customerServiceVisible = true;
    },
    applyCustomerServiceLinks(row) {
      let links = row.CustomerLinks || row.CustomerServiceLinks || {};
      if (typeof links == "string") {
        try {
          links = JSON.parse(links || "{}");
        } catch (e) {
          links = {};
        }
      }
      this.customerServiceFields.forEach((item) => {
        let value = links[item.id] || links[item.key] || row[item.key] || "";
        if (item.key == "CustomService") {
          value = value || row.CustomerServiceLink || row.CustomeService || row.KefuLink || "";
        }
        this.customerServiceDraft[item.key] = value;
      });
      const customerLinks = {};
      this.customerServiceFields.forEach((item) => {
        if (this.customerServiceDraft[item.key]) {
          customerLinks[item.id] = this.customerServiceDraft[item.key];
        }
      });
      this.mFormData.CustomerLinks = JSON.stringify(customerLinks);
    },
    cancelCustomerServiceDialog() {
      this.applyCustomerServiceLinks({
        CustomerLinks: this.mFormData.CustomerLinks,
        CustomerServiceLink: this.mFormData.CustomerServiceLink,
      });
      this.customerServiceVisible = false;
    },
    confirmCustomerServiceLink() {
      for (let i = 0; i < this.customerServiceFields.length; i++) {
        const item = this.customerServiceFields[i];
        const value = this.customerServiceDraft[item.key];
        if (value && !/^https?:\/\/\S+$/i.test(value)) {
          this.$message.error(`${item.label}需要以 http:// 或 https:// 开头`);
          return;
        }
      }
      this.mFormData.CustomerServiceLink = this.customerServiceDraft.CustomService;
      const customerLinks = {};
      this.customerServiceFields.forEach((item) => {
        if (this.customerServiceDraft[item.key]) {
          customerLinks[item.id] = this.customerServiceDraft[item.key];
        }
      });
      this.mFormData.CustomerLinks = JSON.stringify(customerLinks);
      this.customerServiceVisible = false;
      this.$message.success("客服链接配置已保存");
    },
    OnHandleIconSuccess(res, file) {
      this.mFormData.Icon = res.data.filename;
    },
    OnHandleLogoSuccess(res, file) {
      this.mFormData.Logo = res.data.filename;
    },
    OnHandleLogo2Success(res, file) {
      this.mFormData.Logo2 = res.data.filename;
    },
    OnHandleIosIconSuccess(res, file) {
      this.mFormData.IosIcon = res.data.filename;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/webp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isJPG && isLt2M;
    },
    OnClickSure() {
      this.OnReqSave();
    },
    OnReqSave() {
      if (!this.mFormData.SellerName) {
        return this.$message.error(this.$t('EnterOperatorName'));
      }
      if (!this.mFormData.SampleName) {
        return this.$message.error("请输入运营商简称");
      }
      if (!this.mFormData.ShowName) {
        return this.$message.error("请输入显示名称");
      }
      let tData = {
        SellerName: this.mFormData.SellerName,
        State: Number(this.mFormData.State),
        Remark: this.mFormData.Memo,
        SampleName: this.mFormData.SampleName,
        ShowName: this.mFormData.ShowName,
        Icon: this.mFormData.Icon,
        Logo: this.mFormData.Logo,
        Logo2: this.mFormData.Logo2,
        IosIcon: this.mFormData.IosIcon,
        SocialLinks: this.mFormData.SocialLinks || "{}",
        CustomerLinks: this.mFormData.CustomerLinks || "{}",
      };
      if (this.OnIsEdit()) {
        tData.SellerId = Number(this.dialogData.row.SellerId);
        tData.IgnoreSeller = true;
        app.post("/admin/seller/modify", tData, () => {
          app.flushSeller();
          this.dialogData.show = false;
          this.$message.success(this.$t('ModificationSuccessful'));
          app.GetAllSeller();
        });
      } else if (this.OnIsAdd()) {
        app.post("/admin/seller/add", tData, () => {
          app.flushSeller();
          this.dialogData.show = false;
          this.$message.success("添加成功");
          app.GetAllSeller();
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px !important;
  height: 100px !important;
  line-height: 100px !important;
  text-align: center;
}

::v-deep .avatar {
  width: 100px !important;
  height: 100px !important;
  display: block;
  background-color: #c0c0c0;
}

::v-deep .el-upload--text {
  width: 100px !important;
  height: 100px !important;
}
.block {
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 6px 16px;
  margin: -111px 0px 0px 150px;
  background-color: #c0c0c0;
}

.social-link-count {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

::v-deep .seller-social-dialog .el-dialog__body {
  max-height: 62vh;
  overflow-y: auto;
  padding: 18px 35px 8px;
}

::v-deep .seller-social-dialog .el-form-item {
  margin-bottom: 12px;
}

::v-deep .seller-customer-service-dialog .el-dialog__body {
  padding: 24px 35px 8px;
}
</style>
